import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';
import isEmpty from 'lodash/fp/isEmpty';
import { pure } from '@dbk/ui-react-utils';

import Text, { Large, H1 } from '../../../../components/common/text';
import TableRow from '../../../../components/common/table-row';
import {
  SimpleNumber,
  Currency,
} from '../../../../components/common/number';

import styles from './position-header.styles';

function PositionHeader(props) {
  const { labels = {}, position = {}, messages } = props;

  if (isEmpty(position)) {
    return <View><Text>loading</Text></View>;
  }

  return (
    <View style={styles.container} testID="position-header">
      {/* <Text style={styles.securityName} testID="position-header-label">
        {position.securityName}
      </Text> */}
      <H1 secondary>{messages["app.common.pageTitle.transactions"]}</H1>
      <View style={styles.transactionSummary}>
        <TableRow>
          <TableRow.Column
            align="right"
            testID="position-header-item-label"
            width="auto">
            <Text style={styles.label} testID="position-header-item-label">{messages[labels.quantity]}</Text>
          </TableRow.Column>
          <TableRow.Column
            gutter={false}
            testID="position-header-item-value"
            width="auto">
            <SimpleNumber
              minimumFractionDigits={0}
              maximumFractionDigits={2}
              renderProps={{
                style: styles.value,
                testID: 'position-header-item-value',
              }}
              value={position.quantity}
            />
          </TableRow.Column>
        </TableRow>
        <TableRow>
          <TableRow.Column
            align="right"
            testID="position-header-item-label"
            width="auto">
            <Text style={styles.label} testID="position-header-item-label">{messages[labels.marketValue]}</Text>
          </TableRow.Column>
          <TableRow.Column
            gutter={false}
            testID="position-header-item-value"
            wrap={false}
            width="auto">
            <Currency
              value={position.marketValue}
              currency={position.marketValueUnit}
              renderProps={{
                style: styles.value,
                testID: 'position-header-item-value',
              }}
              signBeforeNumber={false}
            />
          </TableRow.Column>
        </TableRow>
        <TableRow>
          <TableRow.Column
            align="right"
            testID="position-header-item-label"
            width="auto">
            <Text
              style={styles.label}
              testID="position-header-item-label"
            >{messages[labels.unrealisedGL]}</Text>
          </TableRow.Column>
          <TableRow.Column
            gutter={false}
            testID="position-header-item-value"
            wrap={false}
            width="auto">
            <Text testID="position-header-item-value">
              <Currency
                value={position.unrealisedGL}
                currency={position.unrealisedGLUnit}
                renderProps={{
                  style: styles.value,
                }}
                signBeforeNumber={false}
              />
            </Text>
          </TableRow.Column>
        </TableRow>
      </View>
    </View>
  );
}

PositionHeader.propTypes = {
  position: PropTypes.shape({
    securityName: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    marketValue: PropTypes.number,
    marketValueUnit: PropTypes.string,
    unrealisedGL: PropTypes.number.isRequired,
    unrealisedGLUnit: PropTypes.string.isRequired,
    unrealisedGLPercentage: PropTypes.number.isRequired,
  }),
  labels: PropTypes.shape({
    quantity: PropTypes.string.isRequired,
    marketValue: PropTypes.string.isRequired,
    unrealisedGL: PropTypes.string.isRequired,
  }),
};

export default pure(PositionHeader);
